import axios from "@/plugins/axios";
// import * as example from "./example";

let url = "/api/v1/shop/products";

export const reviews = {
    // ...example,
    gets(_product, data){
        return axios.get(`${url}/${_product}/reviews`, data).then(result => result.data);
    },
    put(_product, data){
        return axios.put(`${url}/${_product}/reviews/${data._id}`, data).then(result => result.data);
    },
    delete(_product, data){
        return axios.delete(`${url}/${_product}/reviews/${data._id}`).then(result => result.data);
    }
}
